import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { AppService } from '../../app.service';

const FOOTER_CONTENT_KEY = 'FOOTER_HTML';

@Component({
    selector: 'footer',
    standalone: true,
    imports: [],
    providers: [DatePipe],
    templateUrl: './footer-content.component.html',
    styleUrl: './footer-content.component.scss'
})

export class FooterContentComponent {
    private appService = inject(AppService);
    private defaultContent = '';
    footerHTML: SafeHtml = '';
    currentDate: string | null;

    constructor(private sanitizer: DomSanitizer, private datePipe: DatePipe) {
        this.currentDate = this.datePipe.transform(new Date(), 'yyyy');
        this.defaultContent = `
        <a href="https://agileapplications.co.uk" target="_blank" class="text-muted padding text-center">Agile Applications &copy;</a>
        <span class="text-muted">&nbsp;${this.currentDate}</span>`;
    }

    ngOnInit() {
        const footerContent = this.appService.getConfigurationRaw(FOOTER_CONTENT_KEY) || this.defaultContent;
        this.footerHTML = this.sanitizer.bypassSecurityTrustHtml(footerContent);
    }

}
